import React from "react";
import PageWrapper from "./visitnotestemplate.style";
import { connect } from "react-redux";
import PageTitle from "components/common/PageTitle";
import VisitNotesTemplateViewDetails from "components/visitNoteTemplate/VisitNotesTemplateViewDetails";

const VisitNoteTemplateView = props => {
  return (
    <PageWrapper {...props}>
      <div className="pos-relative">
        <PageTitle
          props={props}
          title="sidebar.staticpage"
          className="plr-15"
          breadCrumb={[
            {
              name: "sidebar.dashboard",
              url: "/dashboard"
            },
            {
              name: "sidebar.staticpage",
              url: "/static-page"
            },
            {
              name: "action.view"
            }
          ]}
        />
        <div
          className="back-icon fs-15 demi-bold-text cursor-pointer"
          onClick={() => props.history.push("/static-page")}
        >
          <i className="fas fa-step-backward"></i> Back
        </div>
      </div>
      <div className="user-tbl">
        <VisitNotesTemplateViewDetails {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger
  };
};

export default connect(mapStateToProps, null)(VisitNoteTemplateView);
